import { axiosInstance } from '../../axios'

export const userAddressServices = {
  create: (requestModel: any) => {
    return axiosInstance.post('user-addresses', requestModel)
  },
  update: (id: string, requestModel: any) => {
    return axiosInstance.put(`user-addresses/${id}`, requestModel)
  },
  updateMain: (id: string, requestModel: any) => {
    return axiosInstance.put(`user-addresses/updateMain/${id}`, requestModel)
  },
  findAll: () => {
    return axiosInstance.get('user-addresses')
  },
  findOne: (id: string) => {
    return axiosInstance.get(`user-addresses/${id}`)
  },
  findByUserId: (id: string) => {
    return axiosInstance.get(`user-addresses/findByUserId/${id}`)
  },
  remove: (id: string) => {
    return axiosInstance.delete(`user-addresses/${id}`)
  },
}
